export const Roles = {
  Admin: "admin",
  User: "user",
  // …
};
